<template>
    <article class="message is-info alert-message">
        <div class="message-header">
            <p>{{title}}</p>
            <button class="delete" aria-label="delete" @click.prevent="close"></button>
        </div>
        <div class="message-body">
            {{message}}
        </div>
    </article>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                default: 'Atención'
            },
            message: {
                type: String,
                required: true
            }
        },
        name: 'Message',
        data() {
            return {
                visible: false
            }
        },
        methods: {
            close(){
                this.$emit('closebtn')
            }
        }
    }
</script>

<style lang="css" scoped>
.alert-message{
    position: fixed;
    top: 0;
    left: 0;
    width: 80%;
    margin-left: 10%;
    margin-top: 25%;
    height: 20%;
    z-index: 45;
    -webkit-box-shadow: 0px 0px 7px 0px rgba(0,0,0,0.65);
    -moz-box-shadow: 0px 0px 7px 0px rgba(0,0,0,0.65);
    box-shadow: 0px 0px 7px 0px rgba(0,0,0,0.65);
}
</style>